import { useEffect, useRef } from "react";
import { useButtonSideContext } from "../context/ButtonSideContext";
import { useChooseContext } from "../context/ChooseContext";
import { useEarthquakeContext } from "../context/EarthquakeContext";
import { useMapContext } from "../context/MapContext";
import { useSelectEarthquakeContext } from "../context/SelectEarthquakeContext";
import { useShrinkContext } from "../context/ShrinkContext";
import { Clock, Pulse } from "./Svg";
export default function Card() {
  const [state] = useEarthquakeContext();
  const [stateButton] = useButtonSideContext();
  const [stateSelected, dispatch] = useSelectEarthquakeContext();
  const [, setChoose] = useChooseContext();
  const [map] = useMapContext();
  const [, setShrink] = useShrinkContext();

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prev = usePrevious(stateSelected.selectedEarthquake ?? "");

  const onClickHandler = (e, item) => {
    e.preventDefault();
    dispatch({ type: "selected", payload: item });
    setChoose({ type: "select" });
    setShrink({ type: "toggleShrink" });
  };
  if (map && stateSelected.selectedEarthquake !== prev) {
    map.flyTo(
      [
        stateSelected.selectedEarthquake.Position[0],
        stateSelected.selectedEarthquake.Position[1],
      ],
      9
    );
  }

  return (
    <>
      {state.isLoading
        ? [...Array(4).keys()].map((key) => (
            <div className="card animate-pulse" key={key}>
              <div className="flex flex-col w-full gap-3">
                <div className="flex w-full gap-3">
                  <div className="w-6 h-6 rounded-full bg-slate-200"></div>
                  <div className="flex flex-col gap-1">
                    <p className="w-16 h-3 rounded bg-slate-200"></p>
                    <span className="w-16 h-2 rounded bg-slate-200"></span>
                  </div>
                </div>
                <div className="mt-2">
                  <p className="w-52 h-3 rounded bg-slate-200"></p>
                  <p className="w-40 h-3 rounded bg-slate-200 mt-2"></p>
                </div>
              </div>
              <div className="card-earthquake">
                <span className="w-8 h-6 rounded bg-slate-200"></span>
                <span className="w-8 h-8 rounded bg-slate-200"></span>
                <span className="w-8 h-2 rounded bg-slate-200"></span>
              </div>
            </div>
          ))
        : stateButton.isFeltEarthquake
        ? state.feltEarthquake.map((item, index) => (
            <div
              className={
                stateSelected.selectedEarthquake.Jam === item.Jam
                  ? "card-active"
                  : "card"
              }
              key={index}
              onClick={(e) => onClickHandler(e, item)}
            >
              <div className="flex flex-col w-full gap-3">
                <div className="flex w-full h-full gap-3">
                  <Clock />
                  <div className="flex flex-col">
                    <p className="card-text-date">{item.Tanggal}</p>
                    <span className="card-text-time">{item.Jam} WIB</span>
                  </div>
                </div>
                <p className="card-text-desc">{item.Wilayah}</p>
              </div>
              <div className="card-earthquake">
                <Pulse size={24} />
                <span className="card-earthquake-mg">{item.Magnitude}</span>
                <span className="card-earthquake-mg-text">Magnitudo</span>
              </div>
            </div>
          ))
        : state.fiveMgEarthquake.map((item, index) => (
            <div
              className={
                stateSelected.selectedEarthquake.Jam === item.Jam
                  ? "card-active"
                  : "card"
              }
              key={index}
              onClick={(e) => onClickHandler(e, item)}
            >
              <div className="flex flex-col w-full gap-3">
                <div className="flex w-full h-full gap-3">
                  <Clock />
                  <div className="flex flex-col">
                    <p className="card-text-date">{item.Tanggal}</p>
                    <span className="card-text-time">{item.Jam} WIB</span>
                  </div>
                </div>
                <p className="card-text-desc">{item.Wilayah}</p>
              </div>
              <div className="card-earthquake">
                <Pulse size={24} />
                <span className="card-earthquake-mg">{item.Magnitude}</span>
                <span className="card-earthquake-mg-text">Magnitudo</span>
              </div>
            </div>
          ))}
    </>
  );
}
